module.exports = __webpack_public_path__ + "media/images/landing/persons/kristyna-sadilkova-722b441239eee5469818e261d72271b5.jpg";